// extracted by mini-css-extract-plugin
module.exports = {"main":"Footer_main__1pwP7","firstDiv":"Footer_firstDiv__27M3o","secondDiv":"Footer_secondDiv__1_QMX","secondDivItems":"Footer_secondDivItems__1AcEh"};